import axios from 'axios';

// Supabase Edge Functions URL
const SUPABASE_URL = process.env.REACT_APP_SUPABASE_URL || 'https://cvmcdnkfrfhhlzwlekab.supabase.co';
const API_URL = process.env.REACT_APP_API_URL || `${SUPABASE_URL}/functions/v1`;

const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Intercepteur pour ajouter le token à chaque requête
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token') || sessionStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Intercepteur pour gérer les erreurs
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Ne pas intercepter les 401 sur les routes auth (login, 2fa, register, etc.)
      // pour laisser le composant afficher le message d'erreur
      const url = error.config?.url || '';
      const isAuthRoute = url.includes('/auth/');
      if (!isAuthRoute) {
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        sessionStorage.removeItem('token');
        sessionStorage.removeItem('user');
        window.location.href = '/login';
      }
    }
    return Promise.reject(error);
  }
);

export default api;
